import React from 'react';
import { getRandomUid } from 'utilities/uuid.service';
import { FcPrevious, FcNext } from 'react-icons/fc';

function TablePaginate({ rows = [], currentPage, setPage, maxCount, defaultLimit, handleChange }) {
  return (
    <div className="d-flex pagination justify-content-end align-items-center tableWrap__pagination">
      <div className="mx-3">Rows per page: </div>
      <div className="mx-3">
        <select value={defaultLimit} onChange={(event) => handleChange(event.target.value, event)}>
          {rows.map((item) => (
            <option key={getRandomUid()} value={item}>
              {item}
            </option>
          ))}
        </select>
      </div>

      <div className="mx-3">
        {currentPage} of {Math.max(Math.ceil(maxCount / defaultLimit), 1)}
      </div>
      <div className="mx-3">
        <span
          style={{ fontSize: '20px', cursor: 'pointer' }}
          onClick={() => {
            const to = Math.max(parseInt(currentPage) - 2, 0);

            setPage(to);
          }}
        >
          <FcPrevious />
        </span>
        <span
          style={{ fontSize: '20px', cursor: 'pointer' }}
          onClick={() => {
            const to = Math.min(parseInt(currentPage), parseInt(maxCount));

            if (to < Math.ceil(maxCount / defaultLimit)) {
              setPage(to);
            }
          }}
        >
          <FcNext style={{ marginTop: '10px' }} />
        </span>
      </div>
    </div>
  );
}

TablePaginate.defaultProps = {
  maxCount: 1,
  currentPage: 0,
  setPage: () => {},
  handleChange: () => {},
  rows: [5, 10, 15, 20, 25],
};

export default TablePaginate;
